<div class="container">
  <h6>
    <span class="title"><strong>Ring Patterns</strong></span>
  </h6>
  <table mat-table [dataSource]="ringPatternArr" class="mat-elevation-z4">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let pattern">
        <ng-container *ngIf="pattern.isFirstEdit">
          <mat-form-field>
            <mat-label>schedule ID</mat-label>
            <input matInput [(ngModel)]="pattern.id" />
          </mat-form-field>
        </ng-container>
        <ng-container *ngIf="!pattern.isFirstEdit">
          {{ pattern.id }}
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let pattern">
        <ng-container *ngIf="pattern.isEditing">
          <mat-form-field>
            <mat-label>Pattern name</mat-label>
            <input type="text" matInput [(ngModel)]="pattern.name" />
          </mat-form-field>
        </ng-container>
        <ng-container *ngIf="!pattern.isEditing">
          {{ pattern.name }}
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="patternCol">
      <th mat-header-cell *matHeaderCellDef>Ring Intervals</th>
      <td mat-cell *matCellDef="let pattern">
        <ng-container *ngIf="pattern.isEditing">
          <div>
            <span *ngFor="let interval of pattern.pattern; let intrIdx = index; trackBy:trackByIndex">
            <input
              class="num-field"
              type="number"
              step="0.1"
              [name]="'patrn'+pattern.id+intrIdx"
              [value]="interval"
              [(ngModel)]="pattern.pattern[intrIdx]"
            />

          </span>
            <button class="btn" (click)="deleteInterval(pattern.pattern)" >-</button>
            <button class="btn" (click)="addNewInterval(pattern.pattern)" >+</button>
        </div>

          <!-- </mat-form-field> -->
        </ng-container>
        <ng-container *ngIf="!pattern.isEditing">
          <mat-icon>notifications</mat-icon>
          <!-- {{pattern.pattern.join(',')}} -->
          <ng-container *ngFor="let interval of pattern.pattern">
            <span>{{ interval }}</span>
            <mat-icon>notifications_notificationsactive</mat-icon>
          </ng-container>
          <button mat-mini-fab class="action-btn" (click)="playPattern(pattern)">Play</button>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="count">
      <th mat-header-cell *matHeaderCellDef>Cnt</th>
      <td
        mat-cell
        *matCellDef="let pattern"
        [ngClass]="{ 'time-container': pattern.isEditing }"
      >
        <ng-container *ngIf="pattern.isEditing">
            <input type="number" style="width:70px" class="num-field" [(ngModel)]="pattern.count" />
        </ng-container>
        <ng-container *ngIf="!pattern.isEditing">
          {{ pattern.count }}
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef>Icon</th>
      <td mat-cell *matCellDef="let pattern">
        <ng-container *ngIf="pattern.isEditing">
          <mat-form-field>
            <mat-label>Icon name</mat-label>
            <input type="text" matInput [(ngModel)]="pattern.icon" />
          </mat-form-field>
        </ng-container>
        <ng-container *ngIf="!pattern.isEditing">
          <!-- <span style="text-wrap: wrap; font-size: xx-small">{{
            pattern.icon
          }}</span> -->
          <mat-icon>{{ pattern.icon }}</mat-icon>
        </ng-container>
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Edit</th>
      <td mat-cell *matCellDef="let pattern">
        <ng-container *ngIf="pattern.isEditing">
          <button
            mat-mini-fab color="primary"
            class="action-btn"
            (click)="updateRingPattern(pattern)"
          >
            Save
          </button>
          <button
            mat-mini-fab
            class="action-btn"
            (click)="cancelEditing(pattern)"
          >
            Back
          </button>
        </ng-container>
        <ng-container *ngIf="!pattern.isEditing">
          <button
            mat-mini-fab
            class="action-btn danger"
            (click)="deletePattern(pattern)"
          >
            <mat-icon>delete_forever</mat-icon>
          </button>
          <button
            mat-mini-fab
            class="action-btn"
            (click)="startEditing(pattern)"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </ng-container>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="patternTblColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: patternTblColumns"></tr>
  </table>
  <button
    mat-fab
    extended="action-btn danger"
    style="margin: 10px"
    (click)="addNewPattern()"
  >
    <mat-icon>add</mat-icon>Add new Pattern
  </button>
</div>
